var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6748 12H22.3605V7.501C22.3605 6.6725 21.6621 6.001 20.8005 6.001H20.2805V8.6565C19.3185 6.378 16.7242 3.5 11.9605 3.5C6.68769 3.5 2.47777 7.9625 3.20161 13.166C3.67949 16.599 6.36269 19.456 9.86593 20.2605C14.4398 21.3115 18.8697 18.794 20.3143 14.786C20.4146 14.5095 20.2586 14.207 19.9643 14.129L18.9602 13.8625C18.7023 13.794 18.4256 13.9225 18.3367 14.165C17.2198 17.21 13.845 19.117 10.3589 18.3175C7.69909 17.707 5.65133 15.5435 5.26965 12.94C4.68309 8.9405 7.91177 5.5 11.9605 5.5C16.2884 5.5 18.162 8.559 18.5588 10H16.1148V10.5C16.1148 11.3285 16.8131 12 17.6748 12Z",
    fill: "#E87722"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.29aec11cc1d8231357f8f6b1593a6b2d.svg";
export { ForwardRef as ReactComponent };